import PDFJSAnnotate from './src/PDFJSAnnotate';

export default PDFJSAnnotate;



// WEBPACK FOOTER //
// ./index.js